<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="优惠券编号" prop="id">
                <a-input v-model="queryParam.id" :maxLength="32" oninput="value=value.replace(/[^\d]/g,'')" :placeholder="$t('请输入')+'优惠券编号'" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="优惠券名称" prop="couponName">
                <a-input v-model="queryParam.couponName" :maxLength="32" :placeholder="$t('请输入')+'优惠券名称'" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="获取方式" prop="getWay">
                <a-select v-model="queryParam.getWay" :placeholder="$t('请选择')+'获取方式'" allow-clear>
                  <a-select-option v-for="(item, index) in customDict.CouponGetWayEnum" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="优惠券类型" prop="couponType">
                <a-select v-model="queryParam.couponType" :placeholder="$t('请选择')+'优惠券类型'"  allow-clear>
                  <a-select-option v-for="(item, index) in customDict.CouponTypeEnum" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="优惠券状态" prop="couponTimeStatus">
                <a-select v-model="queryParam.couponTimeStatus" :placeholder="$t('请选择')+'优惠券状态'" allow-clear>
                  <a-select-option v-for="(item, index) in customDict.CouponTimeStatusEnum" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                   :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                   :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['activity:coupon:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['activity:coupon:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['activity:coupon:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['activity:coupon:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" :level-list="levelList" @ok="getList"/>
      <send-form ref="sendForm"/>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1200' }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="couponImg" slot-scope="text, record">
          <div>
            <img v-if="record.couponImg" :src="record.couponImg" style="width:60px;height:62px;" @click="handleRecordPreview(record.couponImg)" alt="none"/>
          </div>
        </template>
        <span slot="couponType" slot-scope="text, record">
          <custom-dict-tag :options="customDict.CouponTypeEnum" :color="true" :value="record.couponType"/>
        </span>
        <span slot="getWay" slot-scope="text, record">
          <custom-dict-tag :options="customDict.CouponGetWayEnum" :color="true" :value="record.getWay"/>
        </span>
        <span slot="couponStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.CouponStatusEnum" :color="true" :color-array="['green', 'red']" :value="record.couponStatus"/>
        </span>
        <span slot="couponTimeStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.CouponTimeStatusEnum" :color="true" :color-array="['blue', 'green', 'red',]" :value="record.couponTimeStatus"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['activity:coupon:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['activity:coupon:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['activity:coupon:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['activity:coupon:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['activity:coupon:send']" />
          <a @click="$refs.sendForm.handleSend(record.id)" v-hasPermi="['activity:coupon:send']">
             <a-icon type="edit" />手动发券
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCoupon,listCoupon, delCoupon } from '@/api/activity/coupon'
import { listLevel } from '@/api/user/level'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import SendForm from './modules/SendForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Coupon',
  components: {
    CustomDictTag,
    CreateForm,
    SendForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      levelList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantId: 0,
        merchantScope: undefined,
        couponName: undefined,
        couponType: undefined,
        startTime: undefined,
        endTime: undefined,
        useStartTime: undefined,
        useEndTime: undefined,
        suitableType: undefined,
        couponStatus: undefined,
        couponTimeStatus: undefined,
        getWay: undefined,
        levelCondition: undefined,
        mutexType: undefined,
        differentMutex: undefined,
        sameMutex: undefined,
        isCanRefund: undefined,
        sortField: "id",
        sortOrder: "desc",
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '优惠券编号',
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName',
          align: 'center'
        },
        {
          title: '优惠券类型',
          dataIndex: 'couponType',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'couponType' },
          align: 'center'
        },
        {
          title: '使用条件',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'cashCondition',
          align: 'center'
        },
        {
          title: '减免金额',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'reduceAmount',
          align: 'center'
        },
        {
          title: '获取方式',
          dataIndex: 'getWay',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'getWay' },
          align: 'center'
        },
        {
          title: '库存',
          dataIndex: 'stock',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: '上架状态',
          dataIndex: 'couponStatus',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'couponStatus' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'couponTimeStatus',
          scopedSlots: { customRender: 'couponTimeStatus' },
          align: 'center'
        },
        {
          title: '领取开始时间',
          dataIndex: 'startTime',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: '领取结束时间',
          dataIndex: 'endTime',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: '使用开始时间',
          dataIndex: 'useStartTime',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: '使用结束时间',
          dataIndex: 'useEndTime',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 150,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getLevelList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询优惠券列表 */
    getList () {
      this.loading = true
     pageCoupon(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getLevelList () {
      this.loading = true
      listLevel({}).then(response => {
        this.levelList = response.data
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantId: 0,
        merchantScope: undefined,
        couponName: undefined,
        couponType: undefined,
        startTime: undefined,
        endTime: undefined,
        useStartTime: undefined,
        useEndTime: undefined,
        suitableType: undefined,
        couponStatus: undefined,
        couponTimeStatus: undefined,
        getWay: undefined,
        levelCondition: undefined,
        mutexType: undefined,
        differentMutex: undefined,
        sameMutex: undefined,
        isCanRefund: undefined,
        sortField: "id",
        sortOrder: "desc",
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCoupon(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/activity/coupon/platform/export',
            that.queryParam
          , `优惠券_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
